import React, { FC, useContext } from 'react';
import { PlayerID } from '../../../scripts/models/common';
import { Modification, PlayerModel, TeamModel } from '../../../scripts/models/models';
import { labelText, Rating, Ratings } from '../../../scripts/models/ratings';
import { Settings } from '../../../scripts/settings';
import { StarMath } from '../../../scripts/starMath';
import { capitalize, starRound } from '../../../scripts/utility';
import Stars from '../../common/stars/Stars';
import Tooltip from '../../common/tooltip/Tooltip';
import { DataContext } from '../../context/dataLoader/DataLoader';
import { SettingsContext } from '../../context/settings/SettingsLoader';

import './RosterStats.scss';

interface IProps {
    team: TeamModel,
    setPitcher: React.Dispatch<React.SetStateAction<PlayerID | undefined>>,
    showShadows?: boolean,
}

const RosterStats: FC<IProps> = (props) => {
    const { team, setPitcher, showShadows = true } = props

    const data = useContext(DataContext);

    function mouseOverPitcher(pitcher: PlayerID) {
        setPitcher(pitcher);
    }

    function mouseLeave() {
        setPitcher(undefined);
    }

    let rotation: PlayerModel[] = []
    let lineup: PlayerModel[] = []
    let shadows: PlayerModel[] = []

    const playerCollections = data.playerCollections;
    if (playerCollections !== undefined) {
        rotation = playerCollections.playersByTeam[team.id].ROTATION;
        lineup = playerCollections.playersByTeam[team.id].LINEUP;
        shadows = playerCollections.playersByTeam[team.id].SHADOWS;
    }


    return (
        <div className="RosterStats serif">
            <div className="RosterStats-Lineup">
                <div className="RosterStats-Lineup-Names names col">
                    <div>Lineup</div>
                    <NameDisplay players={lineup} />
                </div>

                <StarDisplay players={lineup} rating={Ratings.Batting} />
                <StarDisplay players={lineup} rating={Ratings.Running} />
                <StarDisplay players={lineup} rating={Ratings.Defense} />
                <StarDisplay players={lineup} rating={Ratings.Vibes} />

            </div>

            <div className="RosterStats-Rotation">

                <div className="RosterStats-Rotation-Names names col">
                    <div>Rotation</div>
                    <NameDisplay players={rotation} onMouseOver={(playerId) => { mouseOverPitcher(playerId) }} onMouseLeave={mouseLeave} />
                </div>
                <StarDisplay players={rotation} rating={Ratings.Pitching} />
                <StarDisplay players={rotation} rating={Ratings.Vibes} />
            </div>

            {
                // Shadows
                showShadows && (
                    <div className="RosterStats-Shadows">

                        <div className="RosterStats-Shadows-Names names col">
                            <div>Shadows</div>
                            <NameDisplay players={shadows} />
                        </div>
                        <StarDisplay players={shadows} rating={Ratings.Batting} />
                        <StarDisplay players={shadows} rating={Ratings.Running} />
                        <StarDisplay players={shadows} rating={Ratings.Defense} />
                        <StarDisplay players={shadows} rating={Ratings.Pitching} />
                        <StarDisplay players={shadows} rating={Ratings.Vibes} />
                    </div>
                )
            }
        </div>

    );
}


interface IStarDisplayProps {
    players: PlayerModel[],
    rating: Rating
}
const StarDisplay: FC<IStarDisplayProps> = (props) => {
    const { players, rating } = props

    const settings = useContext(SettingsContext)
    const usePrecise = !!(Settings.lookupSetting("Show precise stars", settings));

    return <div className="col">
        <div>{labelText(rating)}</div>
        {
            players.map((player, index) => {
                let stars = StarMath.getValueForPlayer(rating, player)
                stars = starRound(stars, usePrecise);
                return (
                    <div key={index}>
                        <Stars starCount={stars} />
                    </div>
                )
            })
        }
    </div>
}

interface INameDisplayProps {
    players: PlayerModel[],
    onMouseOver?: (player: PlayerID) => void,
    onMouseLeave?: () => void
}
const NameDisplay: FC<INameDisplayProps> = (props) => {
    const { players, onMouseOver, onMouseLeave } = props;
    return <>
        {

            players.map((player, index) => {
                const modifications = player.modifications.map(mod => {
                    let modification = (mod as { modification: Modification }).modification ?? (mod as Modification)
                    return modification.name.replace(" ", "-").replace("'", "")
                });
                return (
                    <div key={index} className={"" + modifications.join(" ")}
                        onMouseOver={() => { onMouseOver && onMouseOver(player.id) }} onMouseLeave={onMouseLeave}>
                        <div className='playerName'>

                            {player.modifications.length > 0 ? "*" : ""}{player.name}

                            <Tooltip visibility={player.modifications.length > 0 ? 'showOnHover' : ""}>
                                <div className="mods-col">
                                    {
                                        player.modifications.map((item, idx) => {

                                            let modification = (item as { modification: Modification }).modification ?? (item as Modification)
                                            return (
                                                <div key={idx}>{capitalize(modification.name)}</div>
                                            )
                                        })
                                    }
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                )
            })
        }
    </>


}


export default RosterStats;